import { useQuery } from '@tanstack/react-query';
import { OfficeService } from '../../services/generatedApi';

const useBroker = (name: string, officeId: string) => {
  return useQuery(
    ['broker', officeId],
    async () => {
      const response = await OfficeService.officeGetBroker(name, officeId);

      if (!response) {
        throw new Error('Failed to fetch broker data');
      }

      return response;
    },
    { enabled: !!name && !!officeId } // Only run when both are available
  );
};

export default useBroker;
